<template>
    <div>
        <div class="container" style="width:100%;">
            <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">续约订单入库</span></div>
            <el-row type="flex" justify="end">
                <el-button @click="onOpenImport"  icon="el-icon-plus" type="primary">导入</el-button>
            </el-row>
            <el-table 
                :data="renewLogList.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="800"
                        style="width: 80%;margin-top: 10px;" ref="Table" >
                <el-table-column prop="dataMonth" align="center"  label="数据月份"></el-table-column>
                <!-- <el-table-column :key="Math.random()" prop="comeFrom" align="center" width="50" label="来源"></el-table-column> -->
                <el-table-column prop="orderCnt" align="center"  label="订单数量" ></el-table-column> 
                <el-table-column prop="jxsCnt" align="center" label="经销商数量" ></el-table-column> 
                <el-table-column prop="zzyhCnt" align="center"  label="最终用户数量" ></el-table-column>
                <el-table-column prop="name" align="center" label="操作人" ></el-table-column>
                <el-table-column prop="rowTime" align="center"  label="操作时间" ></el-table-column>
                
            
            </el-table>

            <div class="tabListPage">
                <el-pagination @size-change="handleSizeChange" 
                                @current-change="handleCurrentChange" 
                                :current-page="currentPage" 
                                :page-sizes="pageSizes" 
                                :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                                :total="totalCount">
                    </el-pagination>
            </div>
            
        <el-dialog title="导入订单" :visible="importDialogVisible" width="60%"
                        :modal-append-to-body='false'
                        :close-on-click-modal='false'
                        @close="importDialogVisible = false" 
                        append-to-body>
            <el-form :model="importForm" inline style="margin-top: 30px;">
                <el-row>
                    <el-form-item label="数据时期">
                        <el-date-picker
                            v-model="importForm.ym"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="选择月份">
                        </el-date-picker>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="选择订单Excel文件">
                            <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    action="string"
                                    :http-request="uploadFile"
                                    :limit="1"
                                    accept=".xls,.xlsx"
                                    :auto-upload="false">
                                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                                    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传</el-button>
                            </el-upload>
                    </el-form-item>
                </el-row>                                         
            </el-form>
            <div v-if="importNo">
                <el-divider content-position="left"></el-divider>
                <div slot="footer" style="display:flex;justify-content:center;margin-top:5px;">
                    <el-button @click="importDialogVisible = false">关闭</el-button>
                    <el-button style="margin-left:20px;" type="primary" @click="onSaveImport">保存</el-button>
                </div>
            </div>
		</el-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getLatestMonthDateArrayByDate } from "@/utils/time";
import { getToken } from "@/utils/auth";
// import {uploadFile} from "@/api/file";
import {ImportRenewOrderExcel2Final} from "@/api/workSheet";


export default {
    name: 'baseform',
    components: {

      },
    computed: {
        ...mapGetters(['renewLogList','importRenewOrderExcel2Tmp','orderStatusList','productList'])
    },
    data() {
        return {
            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:0,
            // 个数选择器（可修改）
            pageSizes:[20,50,100],
            // 默认每页显示的条数（可修改）
            PageSize:50,

            importDialogVisible:false,
            importForm:{
                ym:''
            },
            // importLog:[],            
            // importMsg:[],
            importNo:0,
            curImportLog:{},
            // selectedList:[],
        };
    },

    async mounted() {
        // await this.$store.dispatch('zc/orderStatusList');
        // await this.$store.dispatch('zc/productList');
        this.onQuery();
    },


    methods: {
        onOpenImport(){
            this.importForm.ym='';
            // this.importLog=[];          
            // this.importMsg=[];
            this.importNo=0;
            this.importDialogVisible=true;
        },

        async onImportClick(){
            
        },

       async onQuery(){
        await this.$store.dispatch("workSheet/renewLogList", {

        }).then(res=>{
            this.$refs.Table.doLayout();
            this.totalCount=this.renewLogList.length
            this.currentPage=1
            
        });

       },

       // 每页显示的条数
        handleSizeChange(val) {
            // 改变每页显示的条数 
            this.PageSize=val
            // 注意：在改变每页显示的条数时，要将页码显示到第一页
            this.currentPage=1
        },
        // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage=val
        },

        async uploadFile(param) {
            console.log('param',param);
            const formData = new FormData()
            formData.append('fileInfo', param.file);
            const loading = this.$loading({
                lock: true,
                text: '读取中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });


            // const {dateArray: [sDate, eDate], title} = this.form, {file: {name: fileName}} = param;
            await this.$store.dispatch("workSheet/importRenewOrderExcel2Tmp", {
                ym:this.importForm.ym,formData
            }).then(res=>{
                
                // this.curImportLog = this.importRenewOrderExcel
                // this.importLog = this.importOrderExcel[0];
                // this.importMsg = this.importOrderExcel[1];
                this.importNo = this.importRenewOrderExcel2Tmp[0].ImportNo;
                loading.close();
                this.$message.success('上传成功');
            }).catch(error => {
                console.log(error)
                loading.close();
            })

        },

        submitUpload(e,file,fileList) {
            // console.log(this.importForm.ym)
            // return
            if (!this.importForm.ym){
                this.$message.error('请选择数据时期');
            }
            this.$refs.upload.submit();
        },

        getRowKey(row) {
            return row.终端客户;
        },

        handleSelectionChange(val) {	
            this.selectedList = val;				
        },
        
        async onSaveImport(){
            
            await ImportRenewOrderExcel2Final({userId: getToken(),importNo:this.importNo}).then(()=>{
                this.onQuery();
                this.$message.success('导入成功');
                this.importDialogVisible=false;
            });
        },
    }
};
</script>

<style scoped>
</style>